<div class="snapshots">

  <ng-container *ngFor="let snapshot of snapshots">
    <div class="item">
      <span class="dark-blue">{{snapshot.value}}</span>
      <span class="blue">{{ ('SNAPSHOT.TYPE.' + snapshot.type) | translate }}</span>
    </div>
  </ng-container>

</div>